import File from "./File";
import FrameImagePreloader from "./FrameImagePreloader";
import PosterImagePositionFull from "./ImagePositions/PosterImagePositionFull";
import FrameImagePositionFull from "./ImagePositions/FrameImagePositionFull";
import ImagePositionKitchen from "./ImagePositions/ImagePositionKitchen";
import None from "./Frames/None";

export default class PosterImageToCanvas
{
    /**
     * @param options
     */
    constructor(options) {
        this.frameShadowOffset = options.frameShadowOffset;
        this.$orgPosterImage = options.$orgPosterImage;
        this.frameImagePreloader = options.frameImagePreloader;
        let dataElement = this.$orgPosterImage.parent().parent().parent().find('.custom-product-data');
        this.defaultFrameImage = dataElement.data('default-frame-image');
        this.frameCount = parseInt(dataElement.data('frame-count'));
        this.posterImagePostfix = '';
        if (this.frameCount > 1) {
            this.posterImagePostfix = '-x' + this.frameCount;
        }
        this.selectedFrame = options.selectedFrame;

        // Notice: Enabled by default
        this.addFrameShadow = true;
        if (this.selectedFrame !== null) {
            this.addFrameShadow = this.selectedFrame.addFrameShadow;
        }

        this.isPoster = parseInt(dataElement.data('is-poster'));
        this.dimensions = {
            framePadding : options.framePadding,
            canvasWidth : this.$orgPosterImage.attr('width'),
            canvasHeight : this.$orgPosterImage.attr('height')
        };
    }

    /**
     * @returns void
     */
    replaceImage() {
        if (!this.isPoster) {
            return;
        }
        let self = this;
        let $parentElement = this.$orgPosterImage.parent();

        let canvas = this.createCanvas($parentElement);

        let frameImage = this.loadFrameImage();

        this.loadPosterAndFrameImage($parentElement, frameImage, (posterImage, frame) => {
            self.drawImages(canvas, $parentElement, posterImage, frameImage, frame);
        });
    }

    /**
     * @param canvas
     * @param $parentElement
     * @param posterImage
     * @param frameImage
     * @param frame
     */
    drawImages(canvas, $parentElement, posterImage, frameImage, frame) {

        self = this;

        // Hide the original image
        this.$orgPosterImage.hide();

        let canvasManipulator = this.getCanvasManipulator(canvas);

        // Remove existing images from the canvas before redrawing
        canvasManipulator.clearRect(0, 0, canvas.width, canvas.height);

        this.injectCanvasElement(canvas, $parentElement);

        let imagePosition = new PosterImagePositionFull(frame, posterImage, self.dimensions);

        // Make sure the image doesn't get unclear during resize
        canvasManipulator.webkitImageSmoothingEnabled = false;
        canvasManipulator.mozImageSmoothingEnabled = false;
        canvasManipulator.imageSmoothingEnabled = false;

        // Draw image to canvas
        canvasManipulator.drawImage(posterImage, imagePosition.x, imagePosition.y, imagePosition.width, imagePosition.height);

        canvasManipulator.globalCompositeOperation = 'source-over';

        let framePosition = new FrameImagePositionFull(frame, posterImage, self.dimensions);

        // Draw frame to canvas
        canvasManipulator.drawImage(frameImage, framePosition.x, framePosition.y, framePosition.width, framePosition.height);

        // Show the thumbnails after the main image is loaded
        jQuery(document).find('.woocommerce div.product div.images .flex-control-thumbs img').show();
    }

    /**
     * @param $parentElement
     */
    createCanvas($parentElement) {
        let $oldCanvas = $parentElement.find('canvas');
        if ($oldCanvas.length > 0) {
            return $oldCanvas.get(0);
        }
        let canvas = document.createElement('canvas');
        canvas.width = this.dimensions.canvasWidth;
        canvas.height = this.dimensions.canvasHeight;
        return canvas;
    }

    /**
     * @param canvas
     * @param $parentElement
     * @returns canvas
     */
    injectCanvasElement(canvas, $parentElement) {
        // Override old canvas if it exists
        let $oldCanvas = $parentElement.find('canvas');
        if ($oldCanvas.length <= 0) {
            // Add new canvas
            $parentElement.append(canvas);
        }
    }

    getCanvasManipulator(canvas) {
        let canvasManipulator = canvas.getContext("2d");

        // WARNING!!!! This shadow ruins the globalCompositeOperation multiply effect
        if (this.addFrameShadow) {
            // Add inner shadow to the frame
            canvasManipulator.shadowOffsetX = this.frameShadowOffset;
            canvasManipulator.shadowOffsetY = this.frameShadowOffset;
            canvasManipulator.shadowColor = 'rgba(0,0,0,0.2)';
            canvasManipulator.shadowBlur = 2;
        }

        return canvasManipulator;
    }

    /**
     * @param $parentElement
     * @param frameImage
     * @param callback
     *
     * @returns {HTMLImageElement}
     */
    loadPosterAndFrameImage($parentElement, frameImage, callback) {
        let $originalImage = $parentElement.find('img');
        let image = new Image();

        const $aElement = $parentElement.find('img').parent('a');
        let originalImageSrc = $aElement.attr('href');

        let frame = this.getFrame(this.selectedFrame);

        $originalImage.attr('data-src', originalImageSrc);

        image.src = originalImageSrc;

        // If no frame
        if (frame.number === 0) {
            image.src = originalImageSrc; // Reset the entire image
        }

        image.width = $originalImage.attr('width');
        image.height = $originalImage.attr('height');

        image.onload = function() {
            callback(image, frame);
        }
    }

    /**
     * @returns {HTMLImageElement}
     */
    loadFrameImage() {
        /** @var frame frame */
        // If none
        if (this.selectedFrame !== null && this.selectedFrame.number === 0) {
            // Get the default frame image
            // this.selectedFrame = this.getFrame(null);
        }

        let frame = this.getFrame(this.selectedFrame);
        return this.frameImagePreloader.getPreloadedFrameImages()[File.removeExtension(frame.image_name + frame.extension)];
    }

    /**
     * @param selectedFrame
     * @returns frame
     */
    getFrame(selectedFrame) {

        let imageName = this.defaultFrameImage + this.posterImagePostfix + '.png';

        if (selectedFrame !== null) {
            imageName = selectedFrame.image_name + selectedFrame.extension;
        }

        let preloadedFrames = FrameImagePreloader.getFrames();

        // We do a regular for loop, or we won't be able to return the object for some reason
        for (let i = 0; i < preloadedFrames.length; i++) {
            if (preloadedFrames[i].image_name + preloadedFrames[i].extension === imageName) {
                return preloadedFrames[i];
            }
        }
    }
}
